export const notificationListActions = {

    LOAD_NOTIFICATIONS:'LOAD_NOTIFICATIONS',

    FETCH_NOTIFICATIONS_SUCCESS:'FETCH_NOTIFICATIONS_SUCCESS',
    FETCH_NOTIFICATIONS_FAILED:'FETCH_NOTIFICATIONS_FAILED',
    FETCH_NOTIFICATIONS_PENDING:'FETCH_NOTIFICATIONS_PENDING',

    fetchNotificationsSuccess: (notificationListId, {data}) => ({
      type: notificationListActions.FETCH_NOTIFICATIONS_SUCCESS,
      payload: {
        notificationListId,
        data
      }
    }),

    fetchNotificationsFailed: error =>({
        type:notificationListActions.FETCH_NOTIFICATIONS_FAILED,
        payload: error
    }),

    fetchNotificationsPending: notificationListId =>({
        type:notificationListActions.FETCH_NOTIFICATIONS_PENDING,
        payload:{
          notificationListId
        }
    }),

    loadNotifications: ( notificationListId, sessionId ) => {

      return ({
        type: notificationListActions.LOAD_NOTIFICATIONS,
        payload: {
          notificationListId,
          sessionId
        }
      })
    }
}

export const notificationListRequestActions = {
    failed: notificationListActions.fetchNotificationsFailed,
    success: notificationListActions.fetchNotificationsSuccess,
    pending: notificationListActions.fetchNotificationsPending
}
